import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
//  
import { environment } from '@env/environment';
import { fetchAuthSession } from '@aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  // Worker reference for proper cleanup
  private notificationWorker: Worker | undefined;
  
  constructor(private readonly httpService: AmplifyHttpClient) {}

  updateReminder(id) {
    const data = {
      reminder_id: id,
    };
    return this.httpService.post<any>(`api/vault/vault-user-form-expiration-reminder-read`, data, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReminders() {
    return this.httpService.get<any>(`api/vault/vault-user-form-expiration-reminder`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getNotifications() {
    return this.httpService.get<any>(`api/user/get-notification`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  async getAllNotifications(request) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        // Terminate previous worker if exists
        if (this.notificationWorker) {
          this.notificationWorker.terminate();
        }
        
        let data = {
          token: '',
          url: '',
        };
        this.notificationWorker = new Worker(new URL('./get-all-notification.worker', import.meta.url), { type: 'module' });

         const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/user/get-all-notification`;
        this.notificationWorker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          
          // Terminate worker after receiving data
          if (this.notificationWorker) {
            this.notificationWorker.terminate();
            this.notificationWorker = undefined;
          }

          let res = data.data;
          resolve(res);
        };
        this.notificationWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl(null));
      }
    });
    // return this.httpService.get<any>(`api/user/get-all-notification`, { params: request }).pipe(
    //   map(response => {
    //     if (response.status == 200) {
    //       return response.data;
    //     } else {
    //       return response;
    //     }
    //   }),
    // );
  }

  generateCreatePresignedUrl(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  userNotificationUpdate(params) {
    return this.httpService.post<any>(`api/user/update-notification`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
